/**
 * The universal composer's task-screen door (spec 2026-09-20 §3.2). Read at
 * CALL time (never module scope) so tests can stub the env between cases and
 * the OFF path stays byte-identical, the live-flags.ts pattern. Server twin
 * COMPOSER_TASK_DOOR_V1; OFF on either side, the box sends as it does today.
 * Read as the literal `process.env.NEXT_PUBLIC_…` on purpose: Next inlines
 * that form and no other (the reconciler's web-flag-reads lint says why).
 */
export function isTaskDoorEnabled(): boolean {
  return process.env.NEXT_PUBLIC_COMPOSER_TASK_DOOR_V1 === "true";
}
